/**
 * 参加用URL（/j/{secret}_{token}）の解釈。
 *
 * QRコードから遷移してきた場合のみパスにシークレットとトークンが含まれる。
 * 照合に成功したらセッションCookieが発行されるため、
 * 以降はURLからパラメータを取り除き、履歴やスクリーンショットに残さない。
 */

export interface JoinCredentials {
  secret: string;
  token: string;
}

/** 現在のパスから参加情報を取り出す。該当しなければ null */
export function parseJoinPath(pathname: string): JoinCredentials | null {
  const match = pathname.match(/^\/j\/([^/]+)$/);
  if (match === null) return null;

  const raw = decodeURIComponent(match[1] ?? "");
  const parts = raw.split("_");
  if (parts.length !== 2) return null;

  const [secret, token] = parts;
  if (!secret || !token) return null;
  return { secret, token };
}

/**
 * URLからシークレットとトークンを取り除く。
 * ブラウザの履歴に残さないよう replaceState を使う。
 */
export function clearJoinPath(): void {
  if (typeof window === "undefined") return;
  if (window.location.pathname.startsWith("/j/")) {
    window.history.replaceState(null, "", "/");
  }
}
